import React from 'react'

// components

export const Html = ({ html }) => (html ? <div dangerouslySetInnerHTML={{ __html: html }} /> : null)
